// extracted by mini-css-extract-plugin
export default {"container":"star-bar-rating__container___1vAbZ","section-heading":"star-bar-rating__section-heading___2fhHk","by-review":"star-bar-rating__by-review___10uPh"};